export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["造成您的不便敬請見諒"])},
  "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["網站定期維護中，維護期間網頁將無法正常使用及瀏覽<br/>請稍後再試。"])},
  "copyright": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["技嘉科技股份有限公司。 著作權所有，並保留一切權利。"])},
  "termsOfUse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["網站服務條款"])},
  "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隱私權政策"])}
}